
import { useState } from 'react';

const testimonials = [
  {
    quote:
      'Daliah Secret transformed my daily routine into a ritual. The depth and longevity of their perfumes are unlike anything I\u2019ve experienced. You can truly feel the quality in every drop.',
    name: 'Amira Hassan',
    title: 'Loyal Customer, Dubai',
    image:
      'https://public.readdy.ai/ai/img_res/63b42c1862625baf2b58a173c6b35663.jpg',
  },
  {
    quote:
      'As someone with very sensitive hair, finding the right oil was a struggle for years. Daliah Secret\u2019s argan blend is the only product that nourishes without weighing my hair down. Absolutely life-changing.',
    name: 'Sophie Laurent',
    title: 'Beauty Editor, Paris',
    image:
      'https://readdy.ai/api/search-image?query=stylish%20french%20woman%20portrait%20with%20natural%20makeup%20and%20confident%20expression%2C%20soft%20studio%20lighting%20against%20clean%20light%20gray%20background%2C%20professional%20editorial%20headshot%20photography%2C%20elegant%20and%20sophisticated%20look&width=200&height=200&seq=about-test-2&orientation=squarish',
  },
  {
    quote:
      'I gifted the Rose Oud perfume to my mother and she called me in tears. It reminded her of her grandmother\u2019s garden. That\u2019s the magic of Daliah Secret — they bottle emotions, not just scents.',
    name: 'Liam Chen',
    title: 'Repeat Customer, London',
    image:
      'https://readdy.ai/api/search-image?query=young%20professional%20asian%20man%20portrait%20with%20warm%20genuine%20smile%2C%20soft%20natural%20lighting%20against%20clean%20neutral%20background%2C%20professional%20headshot%20photography%20with%20modern%20casual%20style%2C%20approachable%20and%20friendly%20expression&width=200&height=200&seq=about-test-3&orientation=squarish',
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  const handlePrev = () => {
    setActive((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActive((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[active];

  return (
    <section className="py-24 bg-[#1B5E20]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#A5D6A7] text-sm tracking-[0.2em] mb-3 font-medium">
            WHAT PEOPLE SAY
          </p>
          <h2 className="text-4xl font-serif text-white">
            Stories from Our Community
          </h2>
        </div>

        <div className="max-w-3xl mx-auto text-center">
          <div className="mb-8">
            <div className="w-20 h-20 rounded-full overflow-hidden mx-auto mb-6 border-2 border-[#A5D6A7]">
              <img
                src={current.image}
                alt={current.name}
                className="w-full h-full object-cover"
              />
            </div>
            <i className="ri-double-quotes-l text-4xl text-[#A5D6A7]/40 block mb-4"></i>
            <p className="text-white/90 text-lg font-light leading-relaxed mb-8 font-serif italic min-h-[96px]">
              {current.quote}
            </p>
            <p className="text-white font-medium text-sm tracking-wide">{current.name}</p>
            <p className="text-[#A5D6A7] text-xs mt-1">{current.title}</p>
          </div>

          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={handlePrev}
              className="w-11 h-11 rounded-full border border-[#A5D6A7]/40 flex items-center justify-center hover:border-[#A5D6A7] hover:bg-[#A5D6A7]/10 transition-all cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-s-line text-white text-lg"></i>
            </button>
            <div className="flex items-center gap-2">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setActive(idx)}
                  className={`rounded-full transition-all cursor-pointer ${
                    idx === active
                      ? 'w-8 h-2 bg-[#A5D6A7]'
                      : 'w-2 h-2 bg-white/30 hover:bg-white/50'
                  }`}
                  aria-label={`Go to testimonial ${idx + 1}`}
                />
              ))}
            </div>
            <button
              onClick={handleNext}
              className="w-11 h-11 rounded-full border border-[#A5D6A7]/40 flex items-center justify-center hover:border-[#A5D6A7] hover:bg-[#A5D6A7]/10 transition-all cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-s-line text-white text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
